import { Component, Inject, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { typedFormControl, typedFormGroup } from '@app/common/typed-forms';
import { FeatureLink } from '../../navigation/feature-link';
import { ShopifyLink } from '../../navigation/shopify-migration.service';

@Component({
  selector: 'app-edit-shopify-link-modal',
  templateUrl: './edit-shopify-link-modal.component.html',
  styleUrls: ['./edit-shopify-link-modal.component.scss']
})
export class EditShopifyLinkModalComponent implements OnInit {
  form = typedFormGroup({
    forceRedirect: typedFormControl<boolean>(false),
    path: typedFormControl<string>({
      value: null, disabled: true
    }, [Validators.required]),
    shopifyLink: typedFormControl<string>(null, [Validators.required])
  });

  constructor(
    public dialogRef: MatDialogRef<EditShopifyLinkModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      featureLink: FeatureLink;
      shopifyLink: ShopifyLink;
    }
  ) {}

  ngOnInit() {
    this.form.controls.forceRedirect.setValue(!!this.data.shopifyLink.forceRedirect);
    this.form.controls.path.setValue(this.data.featureLink.path);
    this.form.controls.shopifyLink.setValue(this.data.shopifyLink.shopifyLink);
  }

  submit() {
    const values = this.form.getRawValue();

    const params: ShopifyLink = {
      path: values.path,
      shopifyLink: values.shopifyLink,
      forceRedirect: values.forceRedirect
    };

    this.dialogRef.close(params);
  }
}
